export default {
  dataNotAvailable: 'Data not available'
}
